import { MultiSelectFilterOperator } from './operators';
import { createIdSet } from 'shared/utils/id/entityIds';
import {
  EntityWithId,
  MultiSelectFilterValue,
  isEntityWithIdArray,
  isStringArray,
} from './types';

export function matchesObjectFilter(
  operator: MultiSelectFilterOperator,
  filter: MultiSelectFilterValue,
  cell: EntityWithId[] | null | undefined
): boolean {
  if (!isEntityWithIdArray(cell) || !isStringArray(filter)) {
    // When filter is empty/undefined, consider it as "no filter" = match all
    if (!filter || filter.length === 0) {
      return true;
    }
    // When cell is empty but filter exists, no match
    return false;
  }

  if (filter.length === 0) {
    return true;
  }

  const selectedIds = createIdSet(filter);
  return cell.some((item) => selectedIds.has(item._id));
}
